import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import UserSelectModal from "../common/UserSelectModal";
import Checkbox from "../../../common/Checkbox";

function ResourceUpdateModal({ title, onClose, handleView, typeModalOption, statusModalOption, priceCurrencyModalOption, userTypeModalOption, workplaceModalOption, userModalOption, originRows, MenuUpdateYN, MenuDeleteYN }) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    resource_id: 0,
    resource_name: '',
    resource_type: 0,
    resource_number: '',
    resource_desc: '',
    resource_workplace_id: 0,
    resource_location: '',
    resource_price_currency: 0,
    resource_price: '',
    resource_produce_yn: 'N',
    resource_produce_yn_check: false,
    resource_login_yn: 'N',
    resource_login_yn_check: false,
    resource_start_date: '',
    resource_close_date: '',
    resource_status: 0,
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectModalOpen, setSelectModalOpen] = useState(false);
  const [selectUserData, setSelectUserData] = useState('');
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.resource_manager_user_id, row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));
  
  const handleInitSelect = () => {
    // 자원 정보
    setUpdateUserRows([]);
    
    setInputs({
      resource_id: originRows[0].resource_id,
      resource_name: originRows[0].resource_name,
      resource_type: originRows[0].resource_type,
      resource_number: originRows[0].resource_number,
      resource_desc: originRows[0].resource_desc,
      resource_workplace_id: originRows[0].resource_workplace_id,
      resource_location: originRows[0].resource_location,
      resource_price_currency: (originRows[0].resource_price_currency === undefined || originRows[0].resource_price_currency === null?0:originRows[0].resource_price_currency),
      resource_price: (originRows[0].resource_price === undefined || originRows[0].resource_price === null?0:originRows[0].resource_price),
      resource_produce_yn: originRows[0].resource_produce_yn,
      resource_produce_yn_check: (originRows[0].resource_produce_yn === 'Y'?true:false),
      resource_login_yn: originRows[0].resource_login_yn,
      resource_login_yn_check: (originRows[0].resource_login_yn === 'Y'?true:false),
      resource_start_date: originRows[0].resource_start_date,
      resource_close_date: originRows[0].resource_close_date,
      resource_status: originRows[0].resource_status,
    });

    // 거래처 담당자
    var userData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.resource_manager_seq !== 'undefined' && item.resource_manager_seq === item2.resource_manager_seq;
        }) === index
      );
    });

    setUserRows(userData.map((item, index) => ({
      id: item.resource_manager_seq,
      resource_manager_user_id: item.resource_manager_user_id,
      resource_manager_user_name: item.resource_manager_user_name,
      resource_manager_user_dept_name: item.resource_manager_user_dept_name,
      resource_manager_user_position_name: item.resource_manager_user_position_name,
      resource_manager_user_type: item.resource_manager_user_type,
      row_type: 'O',
      update_type: 'N'
    })));
  }

  const handleSetting = () => {

    setUserColumns([
      (MenuUpdateYN === "Y" && MenuDeleteYN === "Y"?
        {
            field: 'actions',
            headerName: '동작',
            width: 55,
            type:'actions',
            disableClickEventBubbling: true,
            getActions: (params) => [
                ((params.row.update_type === "U")? 
                <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                : (params.row.row_type === "A" && params.row.update_type === "N")? 
                <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
                :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                )
              ],
            headerAlign: 'center', 
            align:'center'
        } : {}),
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'resource_manager_user_id', headerName: 'resource_manager_user_id', width: 0, headerAlign: 'center' },
      { field: 'resource_manager_user_name', headerName: '담당자명', width: 150, headerAlign: 'center', align:'center' },
      { field: 'resource_manager_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'resource_manager_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'resource_manager_user_type', headerName: '담당자유형', type: 'singleSelect', width: 100, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      resource_manager_user_id: false,
      resource_manager_user_name: true,
      resource_manager_user_dept_name: true,
      resource_manager_user_position_name: true,
      resource_manager_user_type: true,
      row_type: false,
      update_type: false
    });
  }

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    resource_manager_user_id: false,
    resource_manager_user_name: true,
    resource_manager_user_dept_name: true,
    resource_manager_user_position_name: true,
    resource_manager_user_type: true,
    row_type: false,
    update_type: false
  });
  
  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleInitSelect();
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);
  
  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        resource_manager_user_id: '',
        resource_manager_user_name: '',
        resource_manager_user_dept_name: '',
        resource_manager_user_position_name: '',
        resource_manager_user_type: 0,
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  const onCheckBoxChange = (ynName, type, value) => {
    let yn = ''
    if(value) {
      yn = 'Y'
    } else {  
      yn = 'N'
    }

    const nextInputs = {
        ...inputs,
        [type] : value,
        [ynName] : yn,
    };
    setInputs(nextInputs);
  };

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onNumberChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        //[name]: value.replace(',','').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','), 
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    //자원 담당자 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우
    
    if(oldRow.resource_manager_user_id !== newRow.resource_manager_user_id || oldRow.resource_manager_user_type !== newRow.resource_manager_user_type){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_resource_manager_user_id = '';
      var row_resource_manager_user_name = '';
      var row_resource_manager_user_type = 0;
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.resource_manager_user_id !== '' || newRow.resource_manager_user_name !== '' || (newRow.resource_manager_user_type !== 0 && newRow.resource_manager_user_type !== null)){
          row_resource_manager_user_id = newRow.resource_manager_user_id;
          row_resource_manager_user_name = newRow.resource_manager_user_name;
          row_resource_manager_user_type = newRow.resource_manager_user_type;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && (data.resource_manager_user_id !== newRow.resource_manager_user_id || data.resource_manager_user_name !== newRow.resource_manager_user_name || data.resource_manager_user_type !== newRow.resource_manager_user_type)?
          (
            row_resource_manager_user_id = data.resource_manager_user_id,
            row_resource_manager_user_name = data.resource_manager_user_name,
            row_resource_manager_user_type = data.resource_manager_user_type
          ):""
        )
      }
      
      if(row_resource_manager_user_id === '' && row_resource_manager_user_name === '' && (row_resource_manager_user_type === 0 || row_resource_manager_user_type === null)){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const userAddClick = (object) => {
    //자원 담당자 추가 버튼
    setUserRows((userRows) => [...userRows, { 
      id: Number(appStore.getMaxListID(userRows))+1,
      resource_manager_user_id: '',
      resource_manager_user_name: '',
      resource_manager_user_dept_name: '',
      resource_manager_user_position_name: '',
      resource_manager_user_type: 0,
      row_type:'A',
      update_type: 'N'
    }]);
  };

  const userDeleteClick = (object) => {
    //자원 담당자 삭제 버튼
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    if(object.row.row_type === 'O'){
      setUpdateUserRows(prevRows => [...prevRows, {
        id: object.row.id,
        resource_manager_user_id: object.row.resource_manager_user_id,
        resource_manager_user_name: object.row.resource_manager_user_name,
        resource_manager_user_dept_name: object.row.resource_manager_user_dept_name,
        resource_manager_user_position_name: object.row.resource_manager_user_position_name,
        resource_manager_user_type: object.row.resource_manager_user_type,
        row_type:'O',
        update_type: 'D'
      }]);
    }
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const handleOnCellClick = (params) => {
    if(params.field === 'resource_manager_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        resource_manager_user_id: params.row.resource_manager_user_id,
        resource_manager_user_name: params.row.resource_manager_user_name,
        resource_manager_user_dept_name: params.row.resource_manager_user_dept_name,
        resource_manager_user_position_name: params.row.resource_manager_user_position_name,
        resource_manager_user_type: params.row.resource_manager_user_type,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handleUserClick = (object) => {
    //거래처목록 모달에서 클릭한 값으로 품목 거래처 데이터 설정함.
    if(object.id !== selectUserData.resource_manager_user_id){
      processUserRowUpdate(
        {
          id : selectUserData.id,
          resource_manager_user_id: object.id,
          resource_manager_user_name: object.user_name,
          resource_manager_user_dept_name: object.dept_name,
          resource_manager_user_position_name: object.position_name,
          resource_manager_user_type: selectUserData.resource_manager_user_type,
          row_type: selectUserData.row_type,
          update_type: selectUserData.update_type
        },
        {
          id : selectUserData.id,
          resource_manager_user_id: selectUserData.resource_manager_user_id,
          resource_manager_user_name: selectUserData.resource_manager_user_name,
          resource_manager_user_type: selectUserData.resource_manager_user_type,
          resource_manager_user_dept_name: selectUserData.resource_manager_user_dept_name,
          resource_manager_user_position_name: selectUserData.resource_manager_user_position_name,
          row_type: selectUserData.row_type,
          update_type: selectUserData.update_type
        }
      )
    }
  };

  const handleSave = (event) => {
    let msg = '';
    if((inputs.resource_name).trim() === ''){
      msg = '자원명은 필수 입력 값 입니다.'
    }else if(inputs.resource_type === 0){
      msg = '자원유형은 필수 선택 입니다.'
    }else if((inputs.resource_status) === 0){
      msg = '자원상태는 필수 입력 값 입니다.'
    }else if((inputs.resource_workplace_id) === 0 || (inputs.resource_workplace_id) === null || (inputs.resource_workplace_id) === undefined){
      msg = '사업장은 필수 입력 값 입니다.'
    }
    
    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < userRows.length; i++) {
        const resource_manager_user_id = userRows[i].resource_manager_user_id;
        const resource_manager_user_name = userRows[i].resource_manager_user_name;
        const resource_manager_user_type = userRows[i].resource_manager_user_type;
        for(let j = i+1; j < userRows.length; j++) {
          if(resource_manager_user_id === userRows[j].resource_manager_user_id && resource_manager_user_id !== '' && resource_manager_user_type === userRows[j].resource_manager_user_type && (resource_manager_user_type !== 0 || resource_manager_user_type !== null)) {
            msg = '중복된 담당자+담당자유형이 존재합니다.<br/>[중복된 담당자 : '+resource_manager_user_name+']';
            break;
          }
        }

        if(msg !== '')  {
          break;
        }
      }

      for(let i = 0; i < updateUserRows.length; i++) {
        const resource_manager_user_id = updateUserRows[i].resource_manager_user_id;
        const resource_manager_user_name = updateUserRows[i].resource_manager_user_name;
        const resource_manager_user_type = updateUserRows[i].resource_manager_user_type;
        
        if(resource_manager_user_id === '' || resource_manager_user_name === '') {
          msg = '선택되지 않은 담당자명이 존재합니다.';
          break;
        }
        
        if((resource_manager_user_type === 0 || resource_manager_user_type === null)) {
          msg = '선택되지 않은 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">자원 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      
      axios.post("/api/p/Resource/Reg", {inputs, updateUserRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '자원 수정 완료',
            text: '정상적으로 자원이 수정 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleView();
          });
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });
    }

  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="자원 정보" value="1" />
                <Tab label="자원 담당자" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">자원명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="자원명" value={inputs.resource_name} name="resource_name" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">자원유형<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="자원유형" value={typeModalOption.filter(function (option) { return option.value === inputs.resource_type;  })} onChange={(e) => onSelectChange('resource_type',e.value)} options={typeModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">자원번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="자원번호" value={inputs.resource_number} name="resource_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}/>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">자원상태<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="자원상태" value={statusModalOption.filter(function (option) { return option.value === inputs.resource_status;  })} onChange={(e) => onSelectChange('resource_status',e.value)} options={statusModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                  <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">사업장<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="사업장" value={workplaceModalOption.filter(function (option) { return option.value === inputs.resource_workplace_id;  })} onChange={(e) => onSelectChange('resource_workplace_id',e.value)} options={workplaceModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">자원위치</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="자원위치" value={inputs.resource_location} name="resource_location" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">통화단위</div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="통화단위" value={priceCurrencyModalOption.filter(function (option) { return option.value === inputs.resource_price_currency;  })} onChange={(e) => onSelectChange('resource_price_currency',e.value)} options={priceCurrencyModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">평가금액</div>
                        <div className="modal_filed_input">
                          <input type="number" placeholder="평가금액" value={inputs.resource_price} name="resource_price" onChange={(e) => onNumberChange(e) } style={ { textAlign:'right' } } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title" style={{height: '43px'}}>생산여부</div>
                        <div className="modal_filed_input" style={{marginTop:'4px'}}>
                          <Checkbox checked={inputs.resource_produce_yn_check} onChange={(e) => onCheckBoxChange('resource_produce_yn','resource_produce_yn_check',e)}>
                          </Checkbox>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title" style={{height: '43px'}}>로그인여부</div>
                        <div className="modal_filed_input" style={{marginTop:'4px'}}>
                          <Checkbox checked={inputs.resource_login_yn_check} onChange={(e) => onCheckBoxChange('resource_login_yn','resource_login_yn_check',e)}>
                          </Checkbox>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">취득일자</div>
                        <div className="modal_filed_input">
                          <input type="date" placeholder="취득일자" value={inputs.resource_start_date} name="resource_start_date" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">폐기일자</div>
                        <div className="modal_filed_input">
                          <input type="date" placeholder="폐기일자" value={inputs.resource_close_date} name="resource_close_date" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">설명</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="설명" value={inputs.resource_desc} name="resource_desc" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'
                  processRowUpdate={processUserRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    {updateFlag &&
                    <div className="modal_button">
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>
                    </div> }
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default ResourceUpdateModal;